import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import decode from 'jwt-decode';
import { UtenteDTO } from '../model/newModel';
@Injectable()
export class RoleAdministratorGuardService implements CanActivate {
  constructor(public auth: AuthService, public router: Router) {}
  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (sessionStorage.getItem('currentUser')) {
      const currentUser: UtenteDTO = JSON.parse(
        sessionStorage.getItem('currentUser')
      );
      const ruoloUser = currentUser.gruppo.nome;
      if (
        ruoloUser === 'ADMINISTRATOR' ||
        ruoloUser === 'ADVISOR' ||
        ruoloUser === 'MANAGER DIDATTICO'
      ) {
        return true;
      }
    }
    const currentMenu = JSON.parse(sessionStorage.getItem('currentMenu'));
    this.router.navigate([currentMenu[0].route]);
    return false;
  }
}
